import { render, staticRenderFns } from "./ObservationsReport.vue?vue&type=template&id=445b0f00&"
import script from "./ObservationsReport.vue?vue&type=script&lang=js&"
export * from "./ObservationsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports